<template>
  <div class="lp-selector">
    <div class="lp-selector__section-title">
      {{ sectionTitle }}
    </div>
    <div class="lp-selector__tiles-wrapper">
      <StaticLPTile
        v-for="path in paths"
        :key="path.objectID"
        :selection="selection"
        :path="path"
        @update-selection="updateSelection"
      />
    </div>
  </div>
</template>

<script>
import StaticLPTile from './StaticLPTile.vue'

export default {
  name: 'LearningPathSelector',
  components: {
    StaticLPTile,
  },
  props: {
    selection: {
      type: String,
      required: true,
    },
    paths: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sectionTitle: 'Other Learning Areas',
    }
  },
  methods: {
    updateSelection(selection) {
      this.$emit('update-selection', selection)
    },
  },
}
</script>

<style lang="scss">
.lp-selector {
  display: flex;
  flex-flow: column;
  padding: 0 25px;
  @include desktop {
    flex-flow: row;
    padding: 0 100px;
    max-width: 1440px;
    margin: auto;
    position: relative;
    top: -40px;
  }
  &__section-title {
    font-family: var(--font-medium);
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    color: var(--white);
    padding-bottom: 20px;
    @include tablet {
      padding-bottom: 30px;
    }
    @include desktop {
      font-size: 32px;
      line-height: 38px;
      width: 260px;
      height: 365px;
      word-spacing: 5rem;
      padding-bottom: unset;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  &__tiles-wrapper {
    width: 100%;
    .path-tile:last-of-type {
      margin-right: 0;
    }
    @include tablet {
      display: flex;
    }
    @include desktop {
      display: flex;
    }
  }
}
</style>
